import React, { Component } from "react";
import { connect } from "react-redux";
import { change_Lang } from "../../../actions/Helper_action";
import SellPrintArabic from "./SellPrintArabic";
import SellPrintKurdish from "./SellPrintKurdish";
import { View_Sell_Contract } from "../../../actions_agent/Invoice_action";
import SellPrintEnglish from "./SellPrintEnglish";
class SellPrint extends Component {
  componentDidMount() {
    this.props.View_Sell_Contract(
      this.props.match.params.id,
      this.props.match.params.index
    );
  }
  render() {
    const { lang, sell_invoice_obj } = this.props;
    return (
      <>
        {lang === "en" ? (
          <SellPrintEnglish sell_invoice_obj={sell_invoice_obj} />
        ) : lang === "krd" ? (
          <SellPrintKurdish sell_invoice_obj={sell_invoice_obj} />
        ) : (
          <SellPrintArabic />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.HelperReducer.lang,
    sell_invoice_obj: state.Invoice_Reducer.sell_invoice_obj,
    sell_contracts: state.InvoiceReducer.sell_contracts,
    index_sell_contract: state.InvoiceReducer.index_sell_contract,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    change_Lang: (key) => dispatch(change_Lang(key)),
    View_Sell_Contract: (id, index) => dispatch(View_Sell_Contract(id, index)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SellPrint);
